<template>
  <q-layout view="hHh lpR fFf" :class="loadingStatus ? 'bg-indigo-6' : ''">
    <loading-dialog :show="loadingStatus" />
    <div
      class="row q-px-md q-py-lg"
      v-if="$route.fullPath == '/' || $route.fullPath == '/profile'"
    >
      <template v-if="!loadingStatus">
        <q-btn
          icon="fas fa-bars"
          flat
          round
          color="indigo-6"
          @click="drawerDialog = true"
        />
        <div
          class="text-h4 pc-bold text-grey-9 on-right"
          v-if="$route.fullPath == '/'"
        >
          PassCrate
        </div>
        <div
          class="text-h4 pc-bold text-grey-9 on-right"
          v-if="$route.fullPath == '/profile'"
        >
          {{ currentUser.name }} {{ currentUser.lastName }}
        </div>
      </template>
    </div>
    <q-page-container v-if="!loadingStatus">
      <router-view />
    </q-page-container>
    <q-dialog
      v-model="drawerDialog"
      maximized
      transition-show="slide-right"
      transition-hide="slide-left"
    >
      <q-card class="bg-indigo-6">
        <q-card-section class="q-px-md q-py-lg q-mb-xl">
          <div class="row">
            <q-btn
              icon="fas fa-times"
              flat
              round
              color="amber-6"
              @click="drawerDialog = false"
            />
          </div>
        </q-card-section>
        <q-card-section class="absolute-bottom q-py-sm">
          <q-btn
            label="My passwords"
            no-caps
            rounded
            color="white"
            text-color="indigo-6"
            push
            class="full-width q-py-sm pc-font pc-bold q-mb-md"
            icon="password"
            to="/"
            @click="drawerDialog = false"
          />
          <q-btn
            label="My account"
            no-caps
            rounded
            color="amber-6"
            text-color="white"
            icon="person"
            push
            class="full-width q-py-sm pc-font pc-bold q-mb-md"
            to="/profile"
            @click="drawerDialog = false"
          />
          <q-btn
            label="Logout"
            outline
            no-caps
            rounded
            icon="logout"
            text-color="white"
            class="full-width q-py-sm pc-font pc-bold q-mb-xl"
            @click="logout()"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
import app from "../firebase";
import { getAuth } from "firebase/auth";

export default {
  data() {
    return { drawerDialog: false };
  },
  methods: {
    ...mapActions("authStore", ["logoutUser"]),
    ...mapActions("appStore", [
      "getUserData",
      "getUserPasswords",
      "emptyUserData",
    ]),

    logout() {
      this.emptyUserData();
      this.logoutUser();
    },
    reloadSite() {
      window.location.href = window.location.href;
    },
  },
  computed: {
    ...mapState("appStore", ["loadingStatus", "currentUser"]),
  },
  mounted() {
    const user = getAuth(app).currentUser;
    this.getUserData(user.uid);
    this.getUserPasswords();
  },
};
</script>
